import { put, takeEvery } from 'redux-saga/effects';

function* example() {
    yield put({
        type: 'example/success'
    });
}

export default [takeEvery('example', example)];
